import { EnrolStats } from '../model/stats/Stats';
import { localizeSchoolGrade, SchoolGrade } from '../model/location/School';
import { localizeUserStatus } from '../model/auth/User';
import { localizePaymentStatus, PaymentStatus } from '../model/Payment';

export class StatsHelper {

  private static hasData(values: (number | undefined)[]): boolean {
    return values
      .map(value => value || 0)
      .reduce((value1, value2) => value1 + value2) > 0;
  }

  public static paymentStatusChartLabels(): string[] {
    return [
      localizePaymentStatus(PaymentStatus.successful),
      localizePaymentStatus(PaymentStatus.scheduled),
      localizePaymentStatus(PaymentStatus.pending),
      localizePaymentStatus(PaymentStatus.failed),
    ];
  }

  public static paymentStatusChartData(stats?: EnrolStats): number[] {
    return stats && stats.type
    && this.hasData([stats.status_successful, stats.status_scheduled, stats.status_pending, stats.status_failed])
      ? [
        stats.status_successful || 0,
        stats.status_scheduled || 0,
        stats.status_pending || 0,
        stats.status_failed || 0,
      ]
      : [];
  }

  public static gradeChartLabels(): string[] {
    return [
      localizeSchoolGrade(SchoolGrade.second),
      localizeSchoolGrade(SchoolGrade.third),
      localizeSchoolGrade(SchoolGrade.forth),
      localizeSchoolGrade(SchoolGrade.fifth),
      localizeSchoolGrade(SchoolGrade.sixth),
      localizeSchoolGrade(SchoolGrade.seventh),
      localizeSchoolGrade(SchoolGrade.eighth),
      localizeSchoolGrade(SchoolGrade.ninth),
      localizeSchoolGrade(SchoolGrade.tenth),
      localizeSchoolGrade(SchoolGrade.eleventh)
    ];
  }

  public static gradeChartData(stats?: EnrolStats): number[] {
    return stats && stats.type
    && this.hasData([stats.grade_2, stats.grade_3, stats.grade_4, stats.grade_5, stats.grade_6, stats.grade_7, stats.grade_8, stats.grade_9, stats.grade_10, stats.grade_11])
      ? [
        stats.grade_2 || 0,
        stats.grade_3 || 0,
        stats.grade_4 || 0,
        stats.grade_5 || 0,
        stats.grade_6 || 0,
        stats.grade_7 || 0,
        stats.grade_8 || 0,
        stats.grade_9 || 0,
        stats.grade_10 || 0,
        stats.grade_11 || 0
      ]
      : [];
  }

  public static userStatusChartLabels(): string[] {
    return [
      localizeUserStatus('CONFIRMED'),
      localizeUserStatus('FORCE_CHANGE_PASSWORD'),
      localizeUserStatus('UNKNOWN')
    ];
  }

  public static userStatusChartData(stats?: EnrolStats): number[] {
    return stats && stats.type && this.hasData([stats.user_status_confirmed, stats.user_status_unconfirmed, stats.user_status_other])
      ? [
        stats.user_status_confirmed || 0,
        stats.user_status_unconfirmed || 0,
        stats.user_status_other || 0
      ]
      : [];
  }

  public static chartData(values: (number | undefined)[]): number[] {
    return values?.length && this.hasData(values)
      ? values.map(value => value || 0)
      : [];
  }
}
